module.exports = __webpack_public_path__ + "static/media/logoTurboInternet.4e639da0.png";